/**
 * Centralized Supabase configuration constants.
 * All frontend code should import from here instead of hardcoding URLs.
 */

export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ||
  import.meta.env.NEXT_PUBLIC_SUPABASE_URL;

export const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
  import.meta.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY;

export const SUPABASE_PROJECT_ID =
  import.meta.env.VITE_SUPABASE_PROJECT_ID;

/**
 * The production Supabase project, named explicitly rather than read from the
 * environment. Some writes must land in prod no matter which build is running
 * them -- quick notes are the case today: a note captured while looking at a
 * preview is worthless if it dies with the preview's database.
 *
 * As shipped, `VITE_SUPABASE_URL` is a project-level Vercel variable covering
 * both the production and preview targets, so previews already resolve to this
 * URL. The `dev` branch overrides it to the dev project. This constant is what
 * lets code tell those apart instead of assuming.
 */
export const SUPABASE_PROD_URL = 'https://izwpjcmqlbsrqkuwkime.supabase.co';

/** True when this build talks to the production database. */
export const IS_PROD_SUPABASE = SUPABASE_URL === SUPABASE_PROD_URL;

/** Site URL for self-references (legal pages, emails, etc.) */
export const SITE_URL =
  import.meta.env.VITE_SITE_URL || window.location.origin;

/** Build a full edge function URL */
export function edgeFunctionUrl(functionName: string): string {
  return `${SUPABASE_URL}/functions/v1/${functionName}`;
}

/** Build a Supabase dashboard link */
export function supabaseDashboardUrl(path: string): string {
  return `https://supabase.com/dashboard/project/${SUPABASE_PROJECT_ID}/${path}`;
}
